import 'rxjs/Rx'; // need import this for http part
import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { environment } from '../environments/environment';

@Injectable()
export class CatalogService {

  constructor(private http: Http) {}

  getCatalog(uid: string): Observable<Catalog> {
    return this.http.get(`${environment.apiUrl}/catalogs/${uid}`).map((res: Response) => {
      let catalog: Catalog = res.json();
      return catalog;
    });
  }

  getShopCatalog(code: string, uid: string): Observable<Catalog> {
    return this.http.get(`${environment.apiUrl}/shops/${code}/catalogs/${uid}`).map((res: Response) => {
      let catalog: Catalog = res.json();
      return this.resolveCatalogPagesURL(catalog);
    });
  }

  resolveCatalogPagesURL(catalog: Catalog): Catalog {
    catalog.pages.map(page => {
      let u = page.imgURL;
      let uhd = page.imgURLHD;
      if (page.imgURL.indexOf("/") == 0) {
        page.imgURL = `${environment.apiUrl}${u}`
      }
      if (page.imgURLHD.indexOf("/") == 0) {
        page.imgURLHD = `${environment.apiUrl}${uhd}`
      }
    })
    return catalog
  }

  getShop(code: string): Observable<Shop> {
    return this.http.get(`${environment.apiUrl}/shops/${code}`).map((res: Response) => {
      let shop: Shop = res.json();
      return shop;
    });
  }

  shopOwnsCatalog(shopCode: string, catalogUID: string): Observable<boolean> {
    return this.http.get(`${environment.apiUrl}/shops/${shopCode}/wants-catalog/${catalogUID}`).map((res: Response) => {
      let wants: ShopWantsCatalog = res.json();
      return wants.yes;
    });
  }

  sectorsForCatalog(catalog: Catalog): Observable<Sector[]> {
    return this.http.get(`${environment.apiUrl}/sectors`).map((res: Response) => {
      let sectors: Sector[] = res.json();
      return sectors.filter(sector => {
	let ok: boolean = false;
	for (let suid in catalog.sectorsIdx) {
	  if (suid === sector.uid) {
	    ok = true;
	    break;
	  }
	}
	return ok;
      });
    });
  }

  getSocial(): Observable<Social> {
    return this.http.get(`${environment.apiUrl}/social`).map((res: Response) => {
      let social: Social = res.json();
      return social;
      });
  }
}

export class Shop {
  constructor() {
    this.code = "";
    this.name = "";
    this.status = "";
  }
  name: string;
  code: string;
  status: string;
}

export class Sector {
  uid: string;
  name: string;
}

export class Catalog {
  constructor() {
    this.uid = "";
    this.name = "";
    this.date = "";
    this.sectorsIdx = {};
    this.pages = [];
    this.pushes = [];
    this.legal = "";
  }

  uid: string;
  name: string;
  date: string;
  sectorsIdx: { [uid: string]: number; }
  pages: Page[];
  pushes: ComPush[];
  legal: string;
}

export class Page {
  index: number;
  imgURL: string;
  imgURLHD: string;
  zones: Zone[];
}

export class Zone {
  actions: ZoneAction[];
  x: number;
  y: number;
  w: number;
  h: number;
}

export class ZoneAction {
  type: string;
  data: string;
}

export class ComPush {
  imgURL: string;
  url: string;
}

interface ShopWantsCatalog {
  yes: boolean
}

export class Social {
  logo: IconLink;
  socialMedia: IconLink[];
}

export class IconLink {
  icon: string;
  targetURL: string;
}



// WEBPACK FOOTER //
// ./src/app/catalog.service.ts